import { render, staticRenderFns } from "./setoffstore.vue?vue&type=template&id=4ef9be55&scoped=true&"
import script from "./setoffstore.vue?vue&type=script&lang=js&"
export * from "./setoffstore.vue?vue&type=script&lang=js&"
import style0 from "./setoffstore.vue?vue&type=style&index=0&id=4ef9be55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef9be55",
  null
  
)

export default component.exports